export default __webpack_public_path__ + "media/Blockchain.48851514.svg";